<template>
  <main :class="isBox?'boxPadding':''">
    <tab-header :currentTab="currentTab" />
    <div class="tab-content" :class="{'section-loading': listAreaLoading}">
      <div class="container-fluid mt-4-5" style="min-height: 500px;">
        <div class="row">
          <div class="col-6">
            <h4
              class="text-green mb-3 mt-0 d-flex flex-row justify-content-between align-items-center"
            >
              <span class="text">最新上架</span>
              <a
                v-if="this.recent_data.length > 5"
                class="link font-weight-normal text-underline"
                @click="panelOpen('recentOnlineOpen')"
                style="font-size: 15px;"
              >看更多 ❯</a>
            </h4>
            <div v-for="(single,i) in limit_recent_data" :key="`recent-list-${i}`">
              <div class="recent-block" style="margin-top:24px">
                <!-- <div class="recent-block-head-pink">
                  <span>{{single.category}}</span>
                </div>-->
                <div class="recent-block-head-green">
                  <span>{{single.category}}</span>
                </div>
                <div class="recent-title" @click="jump(single.category, single.cate_serno)">
                  <div class="recent-title_title">{{single.category_name}}</div>
                  <div
                    class="recent-title_subtitle"
                  >{{ single.cust_list ? single.cust_list + '...' : ''}}({{ single.cust_count || '0' }}人)</div>
                </div>
                <!-- <div class="recent-expand" @click="single.expand = !single.expand"> -->
                <div class="recent-expand" @click="toggleExpand(i)">
                  <span>
                    <i v-if="contentIndex == i" class="icon-arrow_up"></i>
                    <i v-else class="icon-arrow_down"></i>
                  </span>
                </div>
              </div>
              <transition name="slide">
                <div class="recent-content" v-show="contentIndex == i">
                  <div>{{single.description}}</div>
                </div>
              </transition>
            </div>
          </div>
          <div class="col-6 mb-5">
            <div class="m-auto" style="width: 90%">
              <h4 class="text-green mb-3 mt-0">行銷名單 TOP 10</h4>
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th width="50">排名</th>
                    <th>名稱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in importantList" :key="`billborad-${i}`">
                    <td class="text-center">{{i + 1}}</td>
                    <td>
                      <!-- 
                      目前正式環境有開啟連結如下
                      精準行銷：精準行銷(High客名單) & 專案推動(特定專案推動)
                      服務/權益：加值服務(VIP專區) 的中類  & 客戶權益(權益類)(停效後快半年、即將停效、滿期年金未辦、保單給付應領未領)
                      整合行銷：全部開啟
                      集團相關：全部開啟
                      -->
                      <span
                        v-if="
                        item.subcategory == '加值服務' || item.subcategory == '精準行銷' || item.subcategory == '專案推動' || 
                        item.subcategory == '客戶權益' || item.subcategory == '法令專區' || item.category == '整合行銷' || item.category == '活動推廣' || item.category == '法令專區' || item.ser_no == '023' || item.ser_no == '026'"
                        class="link text-underline"
                        @click="jump(item.category, item.ser_no)"
                      >{{item.category}} / {{ item.subcategory }} / {{ item.category_name }}</span>
                      <span
                        v-else
                        class="text"
                      >{{item.category}} / {{ item.subcategory }} / {{ item.category_name }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 最新消息看更多 -->
    <recent-online-modal
      :open="recentOnlineOpen"
      :recent-data="recent_data"
      @close="panelClose('recentOnlineOpen')"
    />
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import RecentOnlineModal from "./RecentOnlineModal";
import { getListArea, setListAreaLog } from "@/service";
import TabHeader from "@/desktop/components/ListsArea/TabHeader";
import mxMask from "@/desktop/components/mxMask";

export default {
  name: "ListAreaIndex",
  mixins: [commonMixin],
  components: {
    RecentOnlineModal,
    TabHeader,
    mxMask
  },
  data() {
    return {
      tables: [],
      currentTab: 0,
      currentInfo: null,
      contentIndex: null,
      keyword: "",
      importantList: [],
      showMenuMap: false,
      seasonRecommandModalOpen: false,
      recentOnlineOpen: false,
      recent_data: [],
      limit_recent_data: [], // recent_data 的前五個資料
      listAreaLoading: false,
      mxMaskOpen: false
    };
  },
  computed: {
    ...mapGetters(["UserInfo", "GetCategoryStatus"]),
    isBox() {
      //判斷是否為box   this.UserInfo.userType === 'box'
      return this.UserInfo.userType === "box";
    }
  },
  methods: {
    ...mapActions(["setPageLock", "setListAreaSerNo"]),
    initListAreaIndex() {
      this.panelOpen("mxMaskOpen"); //開啟遮罩
      // 初始化首頁
      getListArea(this.$store.state.userInfo.id).then(result => {
        this.panelClose("mxMaskOpen"); //關閉遮罩
        if (result.header && result.header.status == "200") {
          // 行銷名單 TOP 10
          this.importantList = result.body.top10_list;

          // 最新上架
          this.recent_data = result.body.cate_list.filter(item => {
            //  過濾掉上架 90 天以上的專區

            return this.mixDateDiff(item.upload_date, null) < 91;
          });
          this.recent_data.forEach(item => {
            // 合成客戶名單
            item.cust_list = item.cust_list.join("、").substr(0, 10); // 超過11自截斷
          });

          // 擷取前五個做顯示
          this.limit_recent_data = [...this.recent_data].splice(0, 5);
          this.registerHanlink(); // 難字顯示
        }
      });
    },
    toggleExpand(index) {
      // 切換最新上架 項目內容顯示
      if (index == this.contentIndex) {
        this.contentIndex = null;
      } else {
        this.contentIndex = index;
      }
    },
    jump(tabName, serNo) {
      let linkArea = "";
      let status = this.GetCategoryStatus[serNo];
      if (tabName === "商品行銷") {
        linkArea = "precision-marketing";
      } else if (tabName === "服務/權益") {
        linkArea = "service-right";
      } else if (tabName === "整合行銷") {
        linkArea = "integrated-marketing";
      } else if (tabName === "活動推廣") {
        linkArea = "group-related";
      } else if (tabName === "法令專區") {
        linkArea = "decree-zone";
      }
      this.setListAreaSerNo(serNo); //  更新流水編到 Vuex
      this.$store.state.initCategoryStatus = status; //記錄點選的名單類別
      this.$router.push(`/list-area/${linkArea}?path=${status}`);
      this.setLog(serNo); //新增名單專區log
    },
    setLog(serNo) {
      setListAreaLog(this.$store.state.userInfo.id, serNo, "1").then(result => {
        this.listAreaLoading = false;
        if (result.header && result.header.status == "200") {
          console.log("新增成功");
        } else {
          console.error("新增名單專區log API 錯誤");
        }
      });
    }
  },
  mounted() {
    // 初始化首頁
    this.initListAreaIndex();

    // tab 頁籤切換
    window.$('[data-toggle="tab"]').on("shown.bs.tab", e => {
      let li = window.$(e.target).closest(".nav-item");
      this.currentTab = e.target.dataset.parent;
      this.currentInfo = e.target.dataset.item;
      if (li.className == "dropdown-item") {
        let link = li.querySelector("a");
        window.$(e.target).attr("aria-selected", false);
        window.$(e.target).removeClass("active show");
        window.$(link).addClass("active show");
      }
    });
  }
};
</script>

<style>
.recent-title {
  width: calc(100% - 40px);
  height: 100%;
  float: left;
  padding: 8px;
}
.recent-title_title {
  font-size: 20px;
  font-weight: 900;
  margin-top: 18px;
  cursor: pointer;
  color: #027a39;
}
.recent-title_subtitle {
  font-size: 13px;
  margin-top: 4px;
  font-weight: normal;
}
.recent-expand {
  width: 40px;
  height: 100%;
  float: left;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(2, 122, 57, 0.5);
  cursor: pointer;
  border-left: 2px solid #fff;
}
.recent-content {
  width: 100%;
  height: 87px;
  border: solid 1px #e0e1e3;
  font-size: 14px;
  color: #323a45;
}
.recent-content div {
  padding: 17px 8px;
}
.recent-block {
  width: 100%;
  height: 84px;
  background: #eee;
  position: relative;
  margin-top: 10px;
}
.recent-block-head-pink {
  position: absolute;
  width: 76px;
  height: 25px;
  background-image: linear-gradient(to bottom, #ff57a1, #d52572);
  font-size: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -12.5px;
  left: 0px;
}
.recent-block-head-green {
  position: absolute;
  width: 76px;
  height: 25px;
  background-image: linear-gradient(to bottom, #05b26b, #027a39);
  font-size: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -12.5px;
  left: 0px;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.slide-enter-to,
.slide-leave {
  max-height: 87px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.boxPadding {
  padding-top: 0px !important;
}
</style>
